import { ReactElement } from 'react'

import { getUserFullName } from '@/helpers/getUserFullName'
import { ColleagueViewModel } from '@/models'
import { UserViewModel } from '@/models/User'

export function getUserSelectOptions(users: (UserViewModel | ColleagueViewModel)[]): ReactElement[] {
    return users
        .sort((a, b) => a.firstname.localeCompare(b.firstname))
        .map(user => (
            <option
                key={user.id}
                value={user.id}
            >
                {getUserFullName(user)}
            </option>
        ))
}
